import styled, { css } from 'styled-components';

interface HeaderProps {
  headerColor: string;
  counterColor: string;
}

interface ButtonProps {
  hoverColor: string;
  gameType?: string;
}

interface FooterProps {
  backgroundColor: string;
  isDark: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0.1rem 0.1rem 0.4rem -0.25rem;
  min-width: 28vw;
  min-height: 510px;
  flex: 1;

  @media (max-width: 996px) {
    display: none !important;
  }
`;

export const Header = styled.header<HeaderProps>`
  font-size: 2.5rem;
  text-align: center;
  background: ${(props) => props.headerColor};
  color: #fff;

  > p {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;

    img {
      margin-right: 12px;
      width: 2.25rem;
    }
  }

  span {
    display: flex;
    background-color: ${(props) => props.counterColor};
    justify-content: space-around;
    font-size: 1rem;
    height: 2.5rem;

    p {
      color: #fff;
      display: flex;
      align-items: center;
      margin: 0;

      svg {
        margin-right: 8px;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  > p {
    font-size: 2rem;
    margin: 1.5rem 0;
  }
`;

export const Button = styled.button<ButtonProps>`
  background: transparent;
  margin: 0 0 0.75rem;
  height: 2.75rem;
  width: 18rem;
  transition: transform 0.2s;
  background: #fafafa;
  box-shadow: 0.1rem 0.1rem 0.5rem -0.1rem;
  /* color: ${({ theme }) => theme.text}; */

  p {
    margin: 0;
    font-size: 1.25rem;
    color: ${({ theme }) => theme.black};
  }

  ${(props) =>
    props.gameType === 'CACAPALAVRAS'
      ? css`
          &:first-child {
            cursor: default;
            background: #9fa7f7;

            p {
              color: #fff;
            }
          }

          &:hover:not(:first-child) {
            transform: scale(1.1);
            background: ${props.hoverColor};

            p {
              color: ${({ theme }) => theme.white};
            }
          }
        `
      : css`
          &:hover {
            transform: scale(1.1);
            background: ${props.hoverColor};
            p {
              color: ${({ theme }) => theme.white};
            }
          }
        `}
`;

export const Footer = styled.footer<FooterProps>`
  display: flex;
  flex-direction: column;

  div {
    margin-bottom: 6px;
  }

  p {
    display: flex;

    align-items: center;
    justify-content: center;
    height: 36px;
    text-align: center;
    font-size: 1rem;
    color: #fff;
    background: ${(props) => props.backgroundColor};
    margin: 0;

    svg {
      margin-left: 8px;
      transform: rotate(180deg);
    }
  }

  &::before {
    content: '';
    width: 18rem;
    height: 1px;
    background: ${(props) => (props.isDark ? '#fff' : '#000')};
    opacity: 0.4;
    margin: 0 auto;
    margin-bottom: 12px;
  }
`;
